import { createPortal } from 'react-dom';

function BottomNavigation({
  active,
  onMonitor,
  onMatches,
  onScan,
  onReward,
  onProfile
}) {
  const navStyle = {
    position: 'fixed', zIndex: 50, left: '50%', bottom: 0,
    display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', alignItems: 'end',
    boxSizing: 'border-box', width: 'min(430px, 100%)', minHeight: 76,
    padding: '8px 12px calc(8px + env(safe-area-inset-bottom))',
    transform: 'translateX(-50%)', borderRadius: '26px 26px 0 0',
    color: '#64748b', background: 'rgba(255,255,255,.96)',
    boxShadow: '0 -8px 28px rgba(30,41,59,.15)', backdropFilter: 'blur(18px)',
    fontFamily: '"Noto Sans Thai", "Leelawadee UI", Tahoma, sans-serif'
  };

  const buttonStyle = isActive => ({
    display: 'grid', boxSizing: 'border-box', width: '100%', minHeight: 57,
    margin: 0, padding: 0, placeItems: 'center', alignContent: 'center', gap: 2,
    border: 0, color: isActive ? '#6d3de4' : '#64748b', background: 'transparent',
    font: 'inherit', fontWeight: isActive ? 900 : 700, cursor: 'pointer'
  });

  const scanStyle = {
    ...buttonStyle(false), position: 'relative', zIndex: 1, justifySelf: 'center',
    width: 62, minWidth: 62, height: 62, minHeight: 62, marginTop: -38,
    transform: 'translateY(-26px)', border: '6px solid #fff', borderRadius: '50%',
    color: '#fff', background: 'linear-gradient(135deg,#6366f1,#7c3aed)',
    boxShadow: '0 8px 18px rgba(99,102,241,.42)', fontSize: 24
  };

  const items = [
    { key: 'monitor', icon: '🏸', label: 'ดูคิวลงสนาม', onClick: onMonitor },
    { key: 'matches', icon: '🤝', label: 'รีเควสคู่', onClick: onMatches },
    { key: 'scan', icon: '📷', label: 'สแกน', onClick: onScan },
    { key: 'reward', icon: '🎁', label: 'รางวัล', onClick: onReward },
    { key: 'profile', icon: '👤', label: 'ประวัติ', onClick: onProfile }
  ];

  return createPortal(
    <nav className="app-bottom-nav" aria-label="เมนูด้านล่าง" style={navStyle}>
      {items.map(item => (
        <button
          key={item.key}
          type="button"
          aria-current={active === item.key ? 'page' : undefined}
          aria-label={item.key === 'scan' ? 'สแกน QR' : item.label}
          onClick={item.onClick}
          style={item.key === 'scan' ? scanStyle : buttonStyle(active === item.key)}
        >
          {item.key === 'scan' ? (
            <>
              {item.icon}<small style={{ marginTop: -4, fontSize: 9, fontWeight: 800 }}>{item.label}</small>
            </>
          ) : (
            <>
              <span style={{ fontSize: 22, lineHeight: 1 }}>{item.icon}</span>
              <small style={{ fontSize: 10, lineHeight: 1.2 }}>{item.label}</small>
            </>
          )}
        </button>
      ))}
    </nav>
    ,
    document.body
  );
}

export default BottomNavigation;
